import { createSelector } from "@reduxjs/toolkit";
import { selectActiveBuildingId } from "../building/buildingSlice";
import { buildingsApi } from "@/api";

const EMPTY_CHANNELS = [];

const selectActiveBuildingChannels = (state) => {
  const buildingId = selectActiveBuildingId(state)
  return buildingsApi.endpoints?.getChannelsByBuilding?.select(buildingId)(state)?.data ?? EMPTY_CHANNELS;
}

export const selectChannelIdToDirectionMap = createSelector(
  [selectActiveBuildingChannels],
  (resData) => {
    return resData.reduce((acc, channel) => {
      if (channel?.id) {
        acc[channel.id] = channel?.camera?.direction
      }
      return acc
    }, {});
  }
);

export const selectChannelIdToNameMap = createSelector(
  [selectActiveBuildingChannels],
  (resData) => {
    return resData.reduce((acc, channel) => {
      if (channel?.id) {
        acc[channel.id] = channel?.name
      }
      return acc
    }, {});
  }
);
